import React from "react";
import { FormattedMessage } from "react-intl";

export default {
    helpersCount: {
        name: "helpersCount",
        label: <FormattedMessage id="trip.helpers-count" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    tollStationGatesCount: {
        name: "tollStationGatesCount",
        label: <FormattedMessage id="trip.toll-station-gates-count" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    preTripDistance: {
        name: "preTripDistance",
        label: <FormattedMessage id="trip.pre-trip-distance" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    scalesCount: {
        name: "scalesCount",
        label: <FormattedMessage id="trip.scales-count" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    manualDistance: {
        name: "manualDistance",
        label: <FormattedMessage id="trip.manual-distance" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    tagCount: {
        name: "requestedCount",
        label: <FormattedMessage id="trip.tag-count" />,
        type: "number",
        validation: {
            required: false,
        },
    },
    cost: {
        name: "cost",
        label: <FormattedMessage id="trip.trip-cost" />,
        type: "number",
        validation: {
            required: false,
        },
    },
};
